import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLocationLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8 1.3335C4.96734 1.3335 2.5 3.81917 2.5 6.87516C2.5 10.6318 6.804 14.3335 8 14.3335C9.196 14.3335 13.5 10.6318 13.5 6.87516C13.5 3.81917 11.0327 1.3335 8 1.3335ZM8 2.3335C10.4813 2.3335 12.5 4.37117 12.5 6.87516C12.5 10.0605 8.75067 13.1649 8 13.3309C7.24933 13.1656 3.5 10.0612 3.5 6.87516C3.5 4.37117 5.51867 2.3335 8 2.3335ZM8.00133 4.66683C6.80667 4.66683 5.83467 5.63947 5.83467 6.8348C5.83467 8.02946 6.80667 9.00016 8.00133 9.00016C9.196 9.00016 10.168 8.02946 10.168 6.8348C10.168 5.63947 9.196 4.66683 8.00133 4.66683ZM8.00133 5.66683C8.64467 5.66683 9.168 6.1908 9.168 6.8348C9.168 7.47813 8.64467 8.00016 8.00133 8.00016C7.358 8.00016 6.83467 7.47813 6.83467 6.8348C6.83467 6.1908 7.358 5.66683 8.00133 5.66683Z",
		fill: "currentColor"
	})
});
export default SvgLocationLine;
